import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SuiModule } from 'ng2-semantic-ui';
import { MomentModule } from 'ngx-moment';
import { NgxTrumbowygModule } from 'ngx-trumbowyg';
import { GroupByPipe } from './vqs-tickets/pipes/groupByDate.pipe';
import { SafeHtmlPipe } from './vqs-tickets/pipes/safeHtml.pipe';

import { DROPZONE_CONFIG, DropzoneModule, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: 'https://app.zanoniconsultoria.com.br/post',
  acceptedFiles: 'text/*,image/*,audio/*,video/*,application/*',
  uploadMultiple: false,
  maxFilesize: 20000,
  withCredentials: false,
  headers: {
    "Cache-Control": "",
  }
};

import { VqsTicketsComponent } from './vqs-tickets/vqs-tickets/vqs-tickets.component';
import { VqsTicketsMessagesComponent } from './vqs-tickets/vqs-tickets-messages/vqs-tickets-messages.component';
import { VqsTicketsNewComponent } from './vqs-tickets/vqs-tickets-new/vqs-tickets-new.component';

@NgModule({
  declarations: [
    VqsTicketsComponent,
    VqsTicketsMessagesComponent,
    VqsTicketsNewComponent,
    SafeHtmlPipe,
    GroupByPipe
  ],
  exports: [
    VqsTicketsComponent,
    VqsTicketsMessagesComponent,
    VqsTicketsNewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SuiModule,
    TranslateModule,
    MomentModule,
    NgxTrumbowygModule,
    DropzoneModule
  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    }
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class VqsTicketsModule {}
